import { Component, Input, OnInit } from '@angular/core';
import { DetailCard } from 'src/shared/models/detailCard';

@Component({
  selector: 'app-mini-card',
  templateUrl: './mini-card.component.html',
  styleUrls: ['./mini-card.component.scss']
})
export class MiniCardComponent implements OnInit {
  @Input() cardItem: DetailCard;
  constructor() { }

  ngOnInit(): void {
  }

}
